import { useState } from 'react';

import { useCapabilityValue } from '../../../store/devices/useCapabilityValue';

import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import styles from './DeviceSettingsMaintenanceAction.module.css';

import { MonoButton } from '../../../components/buttons/MonoButton';
import { SpinningIcon } from '../../../components/common/SpinningIcon';
import { TextSmall } from '../../../components/common/text/TextSmall';

export function DeviceSettingsMaintenanceAction(props) {
  const [isLoading, setIsLoading] = useState(false);

  const [, setValue, capabilityObj] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: props.capabilityId,
  });

  return (
    <div className={styles.root}>
      <MonoButton
        styleWidth="full"
        styleFlat={true}
        styleColor="blue"
        onPress={() => {
          if (isLoading === true) {
            return;
          }

          setIsLoading(true);
          setValue(true)
            .catch(() => {})
            .finally(() => {
              setIsLoading(false);
            });
        }}
      >
        {isLoading === true ? (
          <SpinningIcon
            source={glyph.core.spinner}
            color={theme.color.blue}
            size={theme.icon.size_medium}
          />
        ) : (
          capabilityObj?.title
        )}
      </MonoButton>

      <TextSmall color={theme.color.text_body_light}>{capabilityObj?.desc}</TextSmall>
    </div>
  );
}
